export default {
    "condenser-health": {
        "icon":"fa-tint",
        "menu":"Diagnostics",
        "title":"Condenser health",
        "linkTitle":"Condenser",
        "viewType":"plot-list",
        "hasEquipmentSelector":true,
        "equipmentTypeFilter":"chiller",
        "hasOnOnlySwitch":false,
        "plotList":
            [
                {
                    'id': 1,
                    'type':'scatter',
                    'config':{
                        'variable-x': 'Cond_Approach',
                        'variable-y': 'Cond_Approach',
                        'on-only': true,
                        'type': 'dygraph',
                    }
                },
                {
                    'id': 2,
                    'type': 'scatter',
                    'config':{
                        'variable-x': 'SW_Temp_Diff',
                        'variable-y': 'SW_Temp_Diff',
                        'on-only': true,
                        'type': 'dygraph',
                    }
                },
                {
                    'id': 3,
                    'type': 'scatter',
                    'config':{
                        'variable-x': 'SWS_Temp',
                        'variable-y': 'SWS_Temp',
                        'on-only': true,
                        'type': 'dygraph',
                    }
                },
                {
                    'id': 4,
                    'type': 'scatter',
                    'config':{
                        'variable-x': 'Cond_Sat_Refrig_Temp',
                        'variable-y': 'Cond_Sat_Refrig_Temp',
                        'on-only': true,
                        'type': 'dygraph',
                    }
                },
                {
                    'id': 5,
                    'type': 'scatter',
                    'config':{
                        'variable-x': 'Cond_Sat_Refrig_Press',
                        'variable-y': 'Cond_Sat_Refrig_Press',
                        'on-only': true,
                        'type': 'dygraph',
                    }
                }
            ]
    },
    "refrigerant-health": {
        "icon":"fa-vial",
        "menu":"Diagnostics",
        "title":"Refrigerant health",
        "linkTitle":"Refrigerant",
        "viewType":"plot-list",
        "hasEquipmentSelector":false,
        "equipmentTypeFilter":"chiller",
        "hasOnOnlySwitch":true,
        "plotList":
            [
                {
                    'id': 1,
                    'type':'refrigerant-temp-pressure',
                    'config':{
                        'variable-x': 'Cond_Sat_Refrig_Temp',
                        'variable-y': 'Cond_Sat_Refrig_Temp',
                        'on-only': true,
                        'type': 'histogram',
                    }
                },
                {
                    'id': 2,
                    'type':'refrigerant-temp-pressure',
                    'config':{
                        'variable-x': 'Refrigerant_Temp',
                        'variable-y': 'Refrigerant_Temp',
                        'on-only': true,
                        'type': 'histogram',
                    }
                },
                {
                    'id': 3,
                    'type':'refrigerant-temp-pressure',
                    'config':{
                        'variable-x': 'Refrigerant_Temp',
                        'variable-y': 'Refrigerant_Press',
                        'on-only': true,
                        'type': 'scattergl',
                    }
                },
                {
                    'id': 4,
                    'type':'refrigerant-temp-pressure',
                    'config':{
                        'variable-x': 'Cond_Sat_Refrig_Temp',
                        'variable-y': 'Cond_Sat_Refrig_Press',
                        'on-only': true,
                        'type': 'scattergl',
                    }
                }
            ]
    },
    "evaporator-health": {
        "icon":"fa-igloo",
        "menu":"Diagnostics",
        "title":"Evaporator health",
        "linkTitle":"Evaporator",
        "viewType":"plot-list",
        "hasEquipmentSelector":true,
        "equipmentTypeFilter":"chiller",
        "hasOnOnlySwitch":false,
        "plotList":
            [
                {
                    'id': 1,
                    'type':'scatter',
                    'config':{
                        'variable-x': 'Evap Approach',
                        'variable-y': 'Evap Approach',
                        'on-only': true,
                        'type': 'dygraph',
                    }
                },
                {
                    'id': 2,
                    'type': 'scatter',
                    'config':{
                        'variable-x': 'CHW_Temp_Diff',
                        'variable-y': 'CHW_Temp_Diff',
                        'on-only': true,
                        'type': 'dygraph',
                    }
                },
                {
                    'id': 3,
                    'type': 'scatter',
                    'config':{
                        'variable-x': 'Flow_Rate',
                        'variable-y': 'Flow_Rate',
                        'on-only': true,
                        'type': 'dygraph',
                    }
                },
                {
                    'id': 4,
                    'type': 'scatter',
                    'config':{
                        'variable-x': 'CHWS_Temp',
                        'variable-y': 'CHWS_Temp',
                        'on-only': true,
                        'type': 'dygraph',
                    }
                },
                {
                    'id': 5,
                    'type': 'scatter',
                    'config':{
                        'variable-x': 'Refrigerant_Temp',
                        'variable-y': 'Refrigerant_Temp',
                        'on-only': true,
                        'type': 'dygraph',
                    }
                },
                {
                    'id': 6,
                    'type': 'scatter',
                    'config':{
                        'variable-x': 'Refrigerant_Press',
                        'variable-y': 'Refrigerant_Press',
                        'on-only': true,
                        'type': 'dygraph',
                    }
                }
            ]
    },
    "compressor-health": {
        "icon":"fa-cogs",
        "menu":"Diagnostics",
        "title":"Compressor health",
        "linkTitle":"Compressor",
        "viewType":"plot-list",
        "hasEquipmentSelector":false,
        "equipmentTypeFilter":"chiller",
        "hasOnOnlySwitch":true,
        "plotList":
            [
                {
                    'id': 1,
                    'type':'refrigerant-temp-pressure',
                    'config':{
                        'variable-x': 'Oil_Temp',
                        'variable-y': 'Oil_Temp',
                        'on-only': true,
                        'type': 'histogram',
                    }
                },
                {
                    'id': 2,
                    'type':'refrigerant-temp-pressure',
                    'config':{
                        'variable-x': 'Comp_Power',
                        'variable-y': 'Comp_Power',
                        'on-only': true,
                        'type': 'histogram',
                    }
                },
                {
                    'id': 3,
                    'type':'refrigerant-temp-pressure',
                    'config':{
                        'variable-x': 'Oil_Temp',
                        'variable-y': 'Comp_Power',
                        'on-only': true,
                        'type': 'scattergl',
                    }
                }
            ]
    },
};